module.exports = {
  title: ' | Luk & Luk Niezależny Serwis BMW',
  author: 'RzucOkiem.pl',
  description:
    'LUK & LUK Auto Serwis to Niezależny Serwis BMW. Jego siedziba znajduje się w Raciborzu, województwie śląskim od 2003 roku. Jako niezależny serwis BMW świadczymy bardzo szeroki zakres usług. Począwszy od okresowych przeglądów, wymiany opon i mechaniki, po kodowanie, zaawansowaną diagnostykę i naprawy powypadkowe.',
  url: 'https://roc-bmw.netlify.com/',
  image: '/images/og-cover.png',
  logo: 'https://example.com/android-chrome-512x512.png',
  phone: '+48 123 123 123',
};



// WEBPACK FOOTER //
// ./src/config/index.js